/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Ocop_YearInputs */

const vi_shop_ocop_year = /** @type {(inputs: Shop_Ocop_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Năm công nhận`)
};

/**

* @param {Shop_Ocop_YearInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_ocop_year = /** @type {((inputs?: Shop_Ocop_YearInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Ocop_YearInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_ocop_year(inputs)
});